$('[data-filter-value]').click(function () {

  $('[data-filter-value]').each(function (){
    $(this).removeClass('active');
  });

  $(this).addClass('active');

  var article = $(".article-row .featured-article--card");

  article.hide();

  selectedOptions = [];

  article_total = 0;
  filters_active = 0;

  var filtered_value = $(this).data("filter-value")

  // console.log(filtered_value);

  if(filtered_value == 'all'){

    article.each(function () {

      $(this).show();

    });

  }else{
    article.each(function () {

      if ($(this).hasClass(filtered_value)) {
        $(this).show();
      }

      if ($(this).is(":visible")) {
        article_total++;
      }

    });
  }

});